<template>
  <div>
    <ul>
      <li v-for="tornello in tornelli" v-bind:key="tornello.Row">{{tornello.Descrizione}}</li>
    </ul>
  </div>
</template>
<script>
// const CODICE_TORNELLO = '1470';
let headers = new Headers();
headers.append('Content-Type', 'text/plain');
headers.append('Accept', '*/*');
export default {
  name: 'TestTornelli',
  data() {
    return {
      tornelli: []
    };
  },
  mounted() {
    getTornelli()
      .then(response => {
        console.log(response);

        return response.text();
      })
      .then(tornelli => {
        console.log(tornelli);

        this.tornelli = tornelli;
        console.log(this.tornelli);
      })
      .catch(e => {
        console.warn(e);
      });
  }
};
function getTornelli() {
  const url =
    'https://api.allorigins.win/get?url=http://172.16.32.13:3546/api/Reader';
  const fetchConfig = {
    method: 'GET',
    headers: headers,
    mode: 'cors',
    cache: 'default'
  };
  // const contentType = detectMimeType(b64);
  return _sendRequest(url, fetchConfig);
}
function _sendRequest(url, fetchConfig, params) {
  let paramsStrings = [];
  if (params) {
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        paramsStrings.push(
          encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
        );
      }
    }
    url += '?' + paramsStrings.join('&');
  }
  const req = new Request(url, fetchConfig);
  return fetch(req);
}
</script>
<style lang="scss" scoped>
</style>
